import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { ACTION_OTHER } from 'modules/log/log-reasons';
import { closeManualLog, createManualLog } from 'redux/modules/log/effects';

import LogItem from 'modules/log/LogItem';

const enhance = compose(connect(null, { closeManualLog, createManualLog }));

const ManualLog = ({
  shipperOrderId,
  shipperOrdersSkin,
  createManualLog,
  closeManualLog,
  journeyId,
}) => {
  return (
    <LogItem
      showCancelButton={true}
      onCancel={closeManualLog}
      createMode
      onSubmit={createManualLog}
      action={ACTION_OTHER}
      shipperOrdersSkin={shipperOrdersSkin}
      shipperOrderId={shipperOrderId}
      journeyId={journeyId}
    />
  );
};

export default enhance(ManualLog);
